import CrumbTitle from '@/components/crumbTitle/CrumbTitle';
import { GalleryIcon } from '@/icons';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/promos-offer')({
  loader: ({ context }) => {
    context.groupLabel = 'promoManagement.sidebar.title';
    context.childRoutes = [
      {
        id: 'promoManagement.sidebar.menu.promotionalBanners',
        label: 'Promotional Banners',
        path: '/promos-offer/promotional-banner',
        icon: GalleryIcon,
      },
      {
        id: 'promoManagement.sidebar.menu.advertisement',
        label: 'Advertisement',
        path: '/promos-offer/advertisement',
        icon: GalleryIcon,
      },
    ];
    return {
      crumb: <CrumbTitle id="promoManagement.sidebar.title" icon={GalleryIcon} />,
    };
  },

  component: RouteComponent,
});

function RouteComponent() {
  return <Outlet />;
}
